import { Slide } from "@jelly/lesson";
import theory from "../../theory";

const principle: Slide = {
  description:
    "In this principle you can see observe the various material properties of some materials commonly used in the building industry.",
  theory: theory,
  layout: {
    type: "custom052600",
    options: {
      data: {
        "reinforced-concrete": {
          "typical-thickness": "100-300 mm",
          "surface-weight": "250-750",
          "volumetric-weight": "2500",
          "young-modulus": "23",
          porosity: "low",
          smoothness: "varied",
          "typical-form-factor": "wall/floor",
        },
        plaster: {
          "typical-thickness": "5-15 mm",
          "surface-weight": "4-12",
          "volumetric-weight": "800",
          "young-modulus": "2",
          porosity: "low",
          smoothness: "high",
          "typical-form-factor": "layer",
        },
        "gypsum-board": {
          "typical-thickness": "10-15 mm",
          "surface-weight": "5-8",
          "volumetric-weight": "530",
          "young-modulus": "2",
          porosity: "low",
          smoothness: "high",
          "typical-form-factor": "panel",
        },
        "brick-exposed": {
          "typical-thickness": "90 mm",
          "surface-weight": "150",
          "volumetric-weight": "1500",
          "young-modulus": "17",
          porosity: "medium",
          smoothness: "medium",
          "typical-form-factor": "wall",
        },
        masonry: {
          "typical-thickness": "10-20 cm",
          "surface-weight": "100-200",
          "volumetric-weight": "1000-1700",
          "young-modulus": "17",
          porosity: "low",
          smoothness: "high",
          "typical-form-factor": "wall",
        },
        "wooden-panels": {
          "typical-thickness": "5-25 mm",
          "surface-weight": "3-15",
          "volumetric-weight": "550",
          "young-modulus": "3-7",
          porosity: "low",
          smoothness: "high",
          "typical-form-factor": "panel",
        },
        clt: {
          "typical-thickness": "10-25 cm",
          "surface-weight": "45-115",
          "volumetric-weight": "450",
          "young-modulus": "8",
          porosity: "low",
          smoothness: "high",
          "typical-form-factor": "wall/floor",
        },
        timber: {
          "typical-thickness": "5-150 cm",
          "surface-weight": "—",
          "volumetric-weight": "400-900",
          "young-modulus": "8-11",
          porosity: "low",
          smoothness: "high",
          "typical-form-factor": "Beam",
        },
        "polycarbonate-panels": {
          "typical-thickness": "20-50 mm",
          "surface-weight": "2-7",
          "volumetric-weight": "1200",
          "young-modulus": "13",
          porosity: "low",
          smoothness: "high",
          "typical-form-factor": "panel",
        },
        "carpets-fabrics": {
          "typical-thickness": "3-20 mm",
          "surface-weight": "0.6-3",
          "volumetric-weight": "—",
          "young-modulus": "20-30",
          porosity: "high",
          smoothness: "low",
          "typical-form-factor": "layer",
        },
        rubber: {
          "typical-thickness": "5-50 mm",
          "surface-weight": "5-50",
          "volumetric-weight": "1000",
          "young-modulus": "0.0007-0.005",
          porosity: "low",
          smoothness: "medium",
          "typical-form-factor": "layer, block",
        },
        "foam-open-pores": {
          "typical-thickness": "20-100 mm",
          "surface-weight": "0.6-4.5",
          "volumetric-weight": "30-45",
          "young-modulus": "2",
          porosity: "high",
          smoothness: "low",
          "typical-form-factor": "layer",
        },
        "stone-or-glass-wool": {
          "typical-thickness": "50-160 mm",
          "surface-weight": "2-16",
          "volumetric-weight": "40-100",
          "young-modulus": "0.0012",
          porosity: "high",
          smoothness: "low",
          "typical-form-factor": "layer",
        },
        steel: {
          "typical-thickness": "5-20 mm",
          "surface-weight": "400-1500",
          "volumetric-weight": "7800",
          "young-modulus": "200",
          porosity: "low",
          smoothness: "high",
          "typical-form-factor": "panel/beam/layer",
        },
        glass: {
          "typical-thickness": "6-15 mm",
          "surface-weight": "15-45",
          "volumetric-weight": "2500",
          "young-modulus": "47",
          porosity: "low",
          smoothness: "high",
          "typical-form-factor": "panel",
        },
        etfe: {
          "typical-thickness": "100-250µm",
          "surface-weight": "2-8",
          "volumetric-weight": "—",
          "young-modulus": "0.8",
          porosity: "low",
          smoothness: "high",
          "typical-form-factor": "Membrane, cushion",
        },
        metamaterials: {
          "typical-thickness": "—",
          "surface-weight": "—",
          "volumetric-weight": "—",
          "young-modulus": "—",
          porosity: "—",
          smoothness: "—",
          "typical-form-factor": "—",
        },
        "periodic-structures": {
          "typical-thickness": "—",
          "surface-weight": "—",
          "volumetric-weight": "—",
          "young-modulus": "—",
          porosity: "—",
          smoothness: "—",
          "typical-form-factor": "—",
        },
      },
    },
  },
};

export default principle;
